import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { ReactFlowProvider } from 'reactflow';
import { useGetProgramById } from '@frontend/app/hooks';
import { AutomationBuilderV2 } from '@/app/components/automationV2';
import { ProjectsRouteRoot } from '@/app/containers/Projects/constants';

interface AutomationV2ContainerParams {
  projectId: string;
  templateId?: string;
  automationId?: string;
}

const AutomationV2Container: React.FC = () => {
  const history = useHistory();
  const { projectId, templateId, automationId } = useParams<AutomationV2ContainerParams>();
  const {
    data: {
      program = null,
    } = {},
  } = useGetProgramById({
    variables: {
      id: parseInt(projectId, 10),
    },
    skip: !projectId,
    fetchPolicy: 'cache-first',
  });
  const projectName = program?.title || '';

  const handleSave = () => {
    // Navigate back to automation list
    history.push(`${ProjectsRouteRoot}/${projectId}/settings/automation`);
  };

  const handleCancel = () => {
    // Navigate back to automation list
    history.push(`${ProjectsRouteRoot}/${projectId}/settings/automation`);
  };

  // Generate breadcrumbs for main automation routes
  const breadcrumbs = [
    {
      label: projectName,
      onClick: () => history.push(`${ProjectsRouteRoot}/${projectId}`), // Navigate to project dashboard
    },
    {
      label: 'Settings',
      onClick: () => history.push(`${ProjectsRouteRoot}/${projectId}/settings`), // Navigate to project settings
    },
    {
      label: 'Automations',
      onClick: () => history.push(`${ProjectsRouteRoot}/${projectId}/settings/automation`), // Navigate to automations list
    },
  ];

  return (
    <div className="min-h-screen">
      <ReactFlowProvider>
        <AutomationBuilderV2
          projectId={(() => {
            const parsed = parseInt(projectId, 10);
            if (isNaN(parsed)) {
              throw new Error(`Invalid projectId: ${projectId}`);
            }
            return parsed;
          })()}
          templateId={templateId}
          automationId={automationId}
          onSave={handleSave}
          onCancel={handleCancel}
          readOnly={false}
          breadcrumbs={breadcrumbs}
          currentPage={automationId ? 'Edit Automation' : 'Create Automation'}
        />
      </ReactFlowProvider>
    </div>
  );
};

export default AutomationV2Container;
